import React from "react";
import { Navbar, Nav } from "react-bootstrap";

const CustomNavbar = () => {
  return (
    <Navbar bg="white" expand="lg" sticky="top" className="shadow-sm">
      <div className="container">
        <Navbar.Brand
          href="https://www.rechargepos.com"
          className="font-weight-bold text-primary"
        >
          <img
            src="/assets/images/logo.png"
            alt="recharge-pos-logo"
            width="220px"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <Nav.Link href="#features">Features</Nav.Link>
            <Nav.Link href="#screenshots">Screenshots</Nav.Link>
            <Nav.Link href="#download">Download</Nav.Link>
            <Nav.Link href="#faq">FAQ</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default CustomNavbar;
